export const favoriteQueryKeys = {
  favoriteViews: (userId: string | undefined, folderId?: string) => folderId
    ? ['favoriteViews', userId, folderId] as const
    : ['favoriteViews', userId] as const,
  favoriteViewFolders: (userId: string | undefined) => ['favoriteViewFolders', userId] as const,
}
